/*
 *  * Copyright (c) 2020 SQUAREPING INC.
 *  *
 *  * SQUAREPING CONFIDENTIAL
 *  * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *  *
 *  * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 *  * and its suppliers, if any. The intellectual and technical concepts contained herein are
 *  * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 *  * patents in process, and are protected by trade secret or copyright law.
 *  *
 *  * Dissemination of this information or reproduction of this material is strictly forbidden
 *  * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

import React from 'react';
import css from './MaterialInputArea.module.css';
import classNames from 'classnames';

export type MaterialInputAreaProps = React.HTMLProps<HTMLTextAreaElement> & {
  label?: string;
  isRequired?: boolean;
};
const MaterialInputArea = React.forwardRef<HTMLTextAreaElement, MaterialInputAreaProps>(
  (props: MaterialInputAreaProps, ref) => {
    const { className, label, rows = 3, style, ...rest } = props;
    const isCollapse = !!rest.value || !!rest.placeholder;
    return (
      <div style={style} className={classNames(css.container, className)}>
        <textarea {...rest} ref={ref} rows={rows} className={classNames(css.input)} value={rest.value || ''} />
        {!!label && (
          <div className={classNames(css.label, isCollapse && css.collapse)}>
            {label}
            {props.isRequired ? ' *' : ''}
          </div>
        )}
      </div>
    );
  },
);

export default React.memo(MaterialInputArea);

// export * from '@squareping/web.ui.material-input-area';
// export { default } from '@squareping/web.ui.material-input-area';
